var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteVector({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4755 67.4266H14.9837H7.49185V59.9348V52.4429V44.9511V37.4592H0V44.9511V52.4429V59.9348V67.4266V74.9103H7.49185H14.9837H22.4755H29.9674H37.4592V67.4266H29.9674H22.4755Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9677 29.9674H22.4759H14.984H7.49219V37.4593H14.984H22.4759H29.9677H37.4596V44.9511V52.443V59.9348V67.4266H44.9514V59.9348V52.443V44.9511V37.4593V29.9674H37.4596H29.9677Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9511 14.9837H37.4593H29.9674H22.4756V22.4756H29.9674H37.4593H44.9511H52.443V29.9674V37.4593V44.9511V52.443H59.9348V44.9511V37.4593V29.9674V22.4756V14.9837H52.443H44.9511Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4182 0H59.9345H52.4427H44.9508H37.459V7.49185H44.9508H52.4427H59.9345H67.4182V14.9837V22.4755V29.9674V37.4592H74.9101V29.9674V22.4755V14.9837V7.49185V0H67.4182Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteVector);
export default __webpack_public_path__ + "static/media/white-vector.2e821f493a190216dc64fb55fa79b461.svg";
export { ForwardRef as ReactComponent };